import React from 'react';

import {
  EdgeProps,
  getBezierPath,
  getEdgeCenter,
  getMarkerEnd,
} from 'react-flow-renderer';
import { PlusOutlined } from '@ant-design/icons';

import classNames from 'classnames';
import { useAutomationActions } from '@mm/state/actions/automationActions';
import { IAutomationAction } from '@mm/state/model/AutomationModel';
import css from './EdgeButton.module.css';
import { PlusButton, PlusButtonSmall } from '../../NodeTypes/Adder/Adder';

type Props = {
  className?: string;
} & EdgeProps<IAutomationAction>;

const foreignObjectSize = 28;

const HANDLE_PADDING_Y_COMPENSATION_PX = -2;

export const EdgeButton = ({
  className,
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  arrowHeadType,
  markerEndId,
}: Props) => {
  const automationActions = useAutomationActions();

  const onClick = () => {
    console.debug(`EdgeButton: click ${JSON.stringify(data)}`);
    const afterWidgetId = Number(id.split('-')[0]) || undefined;
    const beforeWidgetId = Number(id.split('-')[1]) || undefined;
    const widgetId = afterWidgetId || beforeWidgetId;
    const position = afterWidgetId ? 'after' : 'before';

    automationActions.showActionsList({
      ...data,
      widgetId,
      position,
    } as IAutomationAction);
  };

  const edgePath = getBezierPath({
    sourceX,
    sourceY: sourceY - HANDLE_PADDING_Y_COMPENSATION_PX,
    sourcePosition,
    targetX,
    targetY: targetY + HANDLE_PADDING_Y_COMPENSATION_PX,
    targetPosition,
  });
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <path
        id={id}
        style={style}
        className={classNames(css.path, 'react-flow__edge-path')}
        d={edgePath}
        markerEnd={markerEnd}
      />
      <foreignObject
        width={foreignObjectSize}
        height={foreignObjectSize}
        x={edgeCenterX - foreignObjectSize / 2}
        y={edgeCenterY - foreignObjectSize / 2}
        className={classNames(css.object, 'edgebutton-foreignobject')}
        requiredExtensions="http://www.w3.org/1999/xhtml"
      >
        <div className={css.body}>
          <PlusButtonSmall onClick={onClick} />
        </div>
      </foreignObject>
    </>
  );
};
